module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-tabs"
  }, [_c('div', {
    staticClass: "custom-home-tabs__container"
  }, [_c('div', {
    staticClass: "custom-home-tabs__tabs"
  }, _vm._l((_vm.props.tabs), function(tab) {
    return _c('div', {
      staticClass: "custom-home-tabs__tab"
    }, [_c('div', {
      staticClass: "custom-home-tabs__icon"
    }, [_c('object', {
      attrs: {
        "aria-label": "What sets us apart",
        "type": "image/svg+xml",
        "data": tab.icon
      }
    })]), _c('div', {
      staticClass: "custom-home-tabs__title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('div', {
      staticClass: "custom-home-tabs__content",
      domProps: {
        "innerHTML": _vm._s(tab.text)
      }
    })])
  }))]), _c('div', {
    staticClass: "custom-home-tabs__container"
  }, [_c('router-link', {
    attrs: {
      "to": "/treatment#accelerated"
    }
  }, [_c('div', {
    staticClass: "custom-home-tabs__cta",
    domProps: {
      "innerHTML": _vm._s(_vm.props.cta)
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-436b4716","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-tabs/custom-home-tabs.pug
// module id = 576
// module chunks = 1